import Vue from 'vue'
import Vuex from 'vuex'
import { setProp, deleteProp, arrToObj } from 'bh-mod'

Vue.use(Vuex)

export default {
	state: {
		loadingPage: false,
		getStarted: false,
		allSettings: {},
		groups: {},
		features: {},
		bricks: {},
		buildingAmenities: {},
		buildingImages: {},
		previewModal: {
			show: false,
			data: {}
		},
	},
	mutations: {
		REMOVE_FEATURES(state, data) {
			let features = JSON.parse(JSON.stringify(state.features))
			data.forEach(x => {
				delete features[x]
			})
			state.features = features;
		},
		REMOVE_BRICKS(state, data) {
			let bricks = JSON.parse(JSON.stringify(state.bricks))
			data.forEach(x => {
				delete bricks[x]
			})
			state.bricks = bricks;
		},
		REMOVE_BUILDING_AMENITIES(state, data) {
			let buildingAmenities = JSON.parse(JSON.stringify(state.buildingAmenities))
			data.forEach(x => {
				delete buildingAmenities[x]
			})
			state.buildingAmenities = buildingAmenities;
		},
		REMOVE_BUILDING_IMAGES(state, data) {
			let buildingImages = JSON.parse(JSON.stringify(state.buildingImages))
			data.forEach(x => {
				delete buildingImages[x]
			})
			state.buildingImages = buildingImages;
		},
		SHOW_PREVIEW(state, data) {
			state.previewModal = {
				show: true,
				data
			}
		},
		CLOSE_PREVIEW(state) {
			state.previewModal = {
				show: false,
				data: {}
			}
		},
		LOAD_PAGE: (state, status = !state.loadingPage) => state.loadingPage = status,
		SET_PROP: (state, { where, what, del = false }) => {
			if (del) return deleteProp(state, where)
			setProp(state, where, what)
		},
		SET_APPDATA(state, data) {
			if (!data) data = {}
			let { featureGroups = [], features = [], bricks = [], buildingAmenities = [], buildingImages = [] } = data
			features = features.filter(x => x.group && x.group.id)
			features = features.map(x => {
				return x.group = x.group.id, x
			})
			features = features.map(f => {
				if (!f.order) f.order = 0
				return f
			})
			bricks = bricks.map(f => {
				if (!f.order) f.order = 0
				return f
			})
			buildingAmenities = buildingAmenities.map(f => {
				if (!f.order) f.order = 0
				return f
			})
			buildingImages = buildingImages.map(f => {
				if (!f.order) f.order = 0
				return f
			})

			state.groups = arrToObj(featureGroups)
			state.features = arrToObj(features)
			state.bricks = arrToObj(bricks)
			state.buildingAmenities = arrToObj(buildingAmenities)
			state.buildingImages = arrToObj(buildingImages)
		},
		GET_STARTED: state => {
			state.getStarted = true
		},
		SET_SETTINGS(state, data) {
			if (data.userApp == null) {
				data.userApp = {
					options: {
						seenIntro: false,
					}
				}
			}
			state.allSettings = data
		},
	},
	actions: {
		SET_APPDATA: ({ commit }, data) => commit('SET_APPDATA', data),
	},
}
